import { useMutation } from '@tanstack/react-query';
import { makeRemotePostAuditConfigGenerate } from 'main/factories/usecases';
import { FIVE_SECONDS, showToast, TEN_SECONDS, TOAST_ERROR, TOAST_SUCCESS } from 'lib/utils';

export const useGenerateAuditConfig = () => {
  return useMutation({
    mutationFn: (params: any) => {
      const generateAuditConfigService = makeRemotePostAuditConfigGenerate();
      return generateAuditConfigService.generate(params);
    },
    onError: e => {
      showToast(e.message, TOAST_ERROR, TEN_SECONDS);
    },
    onSuccess: () => {
      showToast('Audit config generated successfully', TOAST_SUCCESS, FIVE_SECONDS);
    },
  });
};
